<div class="page-with-footer partners-section">
  <div class="inner">
    <header class="faq-header">
      <div class="header-inner">
        <h1>Our Partners</h1>
        <h3>Collaborating for Success and Innovation</h3>
      </div>
    </header>
    <section class="content-page centered-flex">
      <div class="inner">

        <div class="inline-select-with-label">
          <label for="">Filter by:</label>
          <ng-select
          class=""
          appearance="outline"
          [id]="'types'"
          placeholder="Select All"
          labelForId="types"
          [searchable]="false"
          [clearable]="false"
          (change)="selectChanged($event)">
            <ng-option *ngFor="let option of typesList" [value]="option.value">{{option.text}}
              <!-- <span class="selected-default">default</span> -->
            </ng-option>

          </ng-select>
        </div>



        <ul class="partners-list">
          <li *ngFor="let p of partnersList|partnerType:selectedType" [@openClose]="toggleSidebar ? 'collapsed' : 'expanded'">
            <div class="partner-inner">
              <h3>
                <a [href]="p.link" target="_blank" rel="noopener noreferrer"><img [src]="'/assets/images/partners/'+p.logo" alt=""></a>
              </h3>
              <p [innerHTML]="p.desc"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</div>
